import React from "react";
import AboutList from "../components/Modules/AboutAlternatingList";
import { AboutUsItems, StringData } from "../data/SiteData";

const Privacy = (props: any) => {
    
    return (
        <>
        <div className="page_header"></div>
        <div className="centered px-5" style={{width:'80%'}}>
        <h1 className="mt-5">Privacy Policy</h1>
<br />
 <br />
<br />
Protecting your private information is our priority. This Statement of Privacy applies to ServeGuardian, and FreeLife Applications, LLC and governs data collection and usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to FreeLife Applications, LLC include freelifeapps.com and FreeLife Apps. The FreeLife Apps application is a Process Server Legal Guideline Tool application. By using the FreeLife Apps application, you consent to the data practices described in this statement.<br />
<br />
 <br />
<br />
Collection of your Personal Information<br />
<br />
In order to better provide you with products and services offered, FreeLife Apps may collect personally identifiable information, such as your:<br />
<br />
 <br />
<br />
 	-	E-mail Address<br />
 <br />
<br />
We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use certain products or services. These may include: (a) registering for an account; (b) entering a sweepstakes or contest sponsored by us or one of our partners; (c) signing up for special offers from selected third parties; (d) sending us an email message; (e) submitting your credit card or other payment information when ordering and purchasing products and services. To wit, we will use your information for, but not limited to, communicating with you in relation to services and/or products you have requested from us. We also may gather additional personal or non-personal information in the future.<br />
<br />
 <br />
<br />
Use of your Personal Information<br />
<br />
FreeLife Apps collects and uses your personal information to operate and deliver the services you have requested.<br />
<br />
 <br />
<br />
FreeLife Apps may also use your personally identifiable information to inform you of other products or services available from FreeLife Apps and its affiliates.<br />
<br />
 <br />
<br />
Sharing Information with Third Parties<br />
<br />
FreeLife Apps does not sell, rent or lease its customer lists to third parties.<br />
<br />
 <br />
<br />
FreeLife Apps may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to FreeLife Apps, and they are required to maintain the confidentiality of your information.<br />
<br />
 <br />
<br />
FreeLife Apps may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on FreeLife Apps or the site; (b) protect and defend the rights or property of FreeLife Apps; and/or (c) act under exigent circumstances to protect the personal safety of users of FreeLife Apps, or the public.<br />
<br />
 <br />
<br />
Right to Deletion<br />
<br />
Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:<br />
<br />
•	Delete your personal information from our records; and<br />
•	Direct any service providers to delete your personal information from their records.<br />
 <br />
<br />
Please note that we may not be able to comply with requests to delete your personal information if it is necessary to:<br />
<br />
•	Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, provide a good or service requested by you, or reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform a contract between you and us;<br />
•	Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those responsible for that activity;<br />
•	Debug to identify and repair errors that impair existing intended functionality;<br />
•	Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided for by law;<br />
•	Comply with the California Electronic Communications Privacy Act;<br />
•	Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when our deletion of the information is likely to render impossible or seriously impair the achievement of such research, provided we have obtained your informed consent;<br />
•	Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us;<br />
•	Comply with an existing legal obligation; or<br />
•	Otherwise use your personal information, internally, in a lawful manner that is compatible with the context in which you provided the information.<br />
 <br />
<br />
Children Under Thirteen<br />
<br />
FreeLife Apps does not knowingly collect personally identifiable information from children under the age of thirteen. If you are under the age of thirteen, you must ask your parent or guardian for permission to use this application.<br />
<br />
 <br />
<br />
E-mail Communications<br />
<br />
From time to time, FreeLife Apps may contact you via email for the purpose of providing announcements, promotional offers, alerts, confirmations, surveys, and/or other general communication. In order to improve our Services, we may receive a notification when you open an email from FreeLife Apps or click on a link therein.<br />
<br />
 <br />
<br />
If you would like to stop receiving marketing or promotional communications via email from FreeLife Apps, you may opt out of such communications by clicking on the UNSUBSCRIBE button.<br />
<br />
 <br />
<br />
Changes to this Statement<br />
<br />
FreeLife Apps reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by sending a notice to the primary email address specified in your account, by placing a prominent notice on our application, and/or by updating any privacy information. Your continued use of the application and/or Services available after such modifications will constitute your: (a) acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound by that Policy.<br />
<br />
 <br />
<br />
Contact Information<br />
<br />
FreeLife Apps welcomes your questions or comments regarding this Statement of Privacy. If you believe that FreeLife Apps has not adhered to this Statement, please contact FreeLife Apps at:<br />
<br />
 <br />
<br />
FreeLife Applications, LLC<br />
<br />
Mt. Vernon, Texas 75457<br />
<br />
 <br />
<br />
Email Address:<br />
<br />
freelifeapplications@gmail.com<br />
<br />
 <br />
<br />
Effective as of October 02, 2023<br />

        </div>
        </>
    );
}

export default Privacy;